module.exports = __webpack_public_path__ + "static/media/README.c3d6f747.md";